module.exports = {
  facialAuthAccountOptionRider: 'deliveroo_facial_auth_rider',
  facialAuthAccountOptionSubRider: 'deliveroo_facial_auth_sub_rider',
};